<template>
  <el-dialog
    title="商品详情"
    :visible.sync="visible"
    width="1000px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
    top="5vh"
  >
    <el-row :gutter="30" v-if="model.id">
      <el-col :span="12">
        <div class="mb-10">基本信息</div>
        <el-descriptions
          title=""
          size="small"
          :column="1"
          border
          :labelStyle="{ 'min-width': '100px' }"
        >
          <el-descriptions-item label="封面">
            <auth-img
              tag="el-image"
              style="width: 60px; height: 60px"
              :src="model.cover || model.commodity_category.cover"
              fit="cover"
            ></auth-img>
          </el-descriptions-item>
          <el-descriptions-item label="件号">{{
            model.part_number
          }}</el-descriptions-item>
          <el-descriptions-item label="替代件号">{{
            model.new_part_number || '无'
          }}</el-descriptions-item>
          <el-descriptions-item label="分类">{{
            model.commodity_category.name
          }}</el-descriptions-item>
          <el-descriptions-item label="PH">{{ model.ph }}</el-descriptions-item>
          <el-descriptions-item label="PH描述">{{
            model.ph_desc
          }}</el-descriptions-item>
          <el-descriptions-item label="类型">{{
            model.type == 1 ? '备件' : '服务'
          }}</el-descriptions-item>
          <el-descriptions-item label="产地">{{
            model.origin_place == 1 ? '国产' : '进口'
          }}</el-descriptions-item>
          <el-descriptions-item label="下单审批">{{
            model.whether_approve == 1 ? '否' : '是'
          }}</el-descriptions-item>
          <el-descriptions-item label="EC审批">{{
            model.ec_approve == 1 ? '否' : '是'
          }}</el-descriptions-item>
          <el-descriptions-item label="单价">{{
            model.price.toFixed(2)
          }}</el-descriptions-item>
          <el-descriptions-item label="英文描述">{{
            model.description
          }}</el-descriptions-item>
          <el-descriptions-item label="中文描述">{{
            model.description_zh
          }}</el-descriptions-item>
        </el-descriptions>
      </el-col>
      <el-col :span="12">
        <div class="mb-10">商品详情</div>
        <div
          class="commodity-content"
          v-html="model.content || model.commodity_category.content"
        ></div>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: false,
    }
  },
}
</script>

<style scoped>
.commodity-content {
  max-height: 70vh;
  overflow-y: auto;
}

/deep/.commodity-content img {
  width: 100%;
}
</style>